// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"fV-z","categoryName":"gV-z","categoryImage":"hV-z","categoryContent":"iV-z","bottomAligned":"jV-z"};